import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { LoaderService } from 'src/app/Services/loader.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare const Swal;

@Component({
  selector: 'g10-rostering-cut-off',
  templateUrl: './rostering-cut-off.component.html',
  styleUrls: ['./rostering-cut-off.component.css']
})
export class RosteringCutOffComponent implements OnInit {

  public orgID: any;
  public routeCutoffData: any;
  public sampleData: any = [
    {
      routeName: "Demo",
      duration: 1.3,
      userAction: 'advanced',
      cutoffID: '1234',
    }
  ];

  public filterTable: boolean = true;
  public tableShow: boolean = false;
  public cols = [
    { key: '#', display: '#', minWidth : '50px' },
    { key: 'name', display: 'Route name',
      config: {
        isTruncate: true,
        truncateData:{
          limit:100,
          concatVal:'...',
        }
      },
      headerConfig:{ isDefault: true}
    },
    { key: 'action', display: 'User action' , minWidth : '80px' , headerConfig:{ isDefault: true}},
    
    { key: 'duration', display: 'Duration' ,  minWidth : '60px' },
    { key: 'date', display: 'Date & Time' ,  minWidth : '100px', headerConfig:{ isDefault: true} },
    { key: 'comment', display: 'Comment', minWidth : '80px',
      config: {
        isTruncate: true,
        truncateData:{
          limit:100,
          concatVal:'...',
        }
      }
    },
    {
      key: 'revert',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'view', color: 'primary', icon: 'View' },
          { display: 'Revert', color: 'warn', icon: 'RevToggleKey',checkKey:true },
        ]
      }
    }
  ];
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }


  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  /* Route cut off Form */
  public closeCutoffFormPopup: boolean = true;
  public formPopup: boolean = true;
  public routeData: any = [];

  /* Route cut off View */
  public closeCutoffViewPopup: boolean = true;
  public selectedCutoffData:any = {};

  constructor(
    public api: ApiService,
    public router: Router,
    public storage: StorageService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public loader: LoaderService,
    public comService: CommonServices,
  ) {
    this.route.paramMap.subscribe(params => {
      this.orgID = params.get('orgID');
    });
  }

  ngOnInit() {
    this.getRouteCutoffData();
  }

  getRouteCutoffData(page = 1, limit = 10, search?) {
    const obj = {
      page: page,
      limit: limit,
    };
    if (search) obj['routeName'] = search;
    this.api.transportManagerRouteCutoffList(obj).then((res: any) => {
      this.processTableData(res.data);
      this.processPagination(res, obj);
    }).catch((err) => {
      console.log(err);
    });
  }

  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totcnt, req.limit),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getRouteCutoffData(data.page, data.limit, this.searchInputValue);
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 300ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getRouteCutoffData(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getRouteCutoffData(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }

  processTableData(data) {
    this.tableShow = false;
    this.routeCutoffData = data.map((route) => {
      let obj = {
        name: route.routeName,
        action: route.action,
        duration: this.comService.getTimeString(route.duration, ':', true),
        uniqID: route.uniqID,
        date: (new Date(route.createdAt)).toLocaleString('sv'),
        comment: route.comment ? route.comment : '',
        revert: route.mode && route.mode!='reverted' ? true : false,
      }
      return obj;
    });
    setTimeout(() => { this.tableShow = true; }, 100);
  }

  onActionHandler(e: any) {
    if (e.action.display.toLowerCase() == 'revert') {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',//'#3085d6',
        //  cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, revert it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.revertRouteCutoff(e.data.uniqID);
        }
      });
    } else if (e.action.display.toLowerCase() == 'view') {
      this.loadViewModal(e.data);

    }
  }

  loadViewModal(data){
    this.selectedCutoffData = data;
    this.closeCutoffViewPopup = false;
  }

  revertRouteCutoff(id) {
    let obj = {
      uniqID:id,
      comment:'revert'
    }
    this.api.transportManagerRouteCutoffRevert(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getRouteCutoffData(1,5,this.searchInputValue);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  formModalPopup() {
    this.closeCutoffFormPopup = false;
  }

  submitRouteCutoff(obj) {
    /* api calls */
    this.api.transportManagerRouteCutoffCreate(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.getRouteCutoffData(1,5,this.searchInputValue);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });

  }
}
